module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#cancel",
      toString: function () {
        return this.url;
      }
    }